<template>
  <div class="layout-wrapper">
    <!-- 顶部导航栏 -->
    <el-container>
      <el-header class="app-header">
        <div class="header-content">
          <!-- Logo和标题 -->
          <div class="header-left">
            <div class="logo-section">
              <img src="@/assets/imgs/logo.png" alt="Logo" class="logo-img">
              <div class="app-title">
                <span class="title-text">供需发布平台</span>
                <span class="title-slogan">连接商机</span>
              </div>
            </div>
          </div>

          <!-- 用户信息 -->
          <div class="header-right" v-if="user && user.id">
            <div class="user-info">
              <div class="avatar-wrapper">
                <el-avatar 
                  :size="42" 
                  :src="user.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"
                  class="user-avatar">
                </el-avatar>
                <span class="online-badge"></span>
              </div>
              
              <el-dropdown :hide-on-click="false" class="user-dropdown">
                <span class="el-dropdown-link">
                  <span class="user-name">{{ user.name || '用户' }}</span>
                  <i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
                  <el-dropdown-item>
                    <div @click="center()" class="dropdown-item">
                      <i class="el-icon-user"></i>
                      <span>个人中心</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item divided>
                    <div @click="exit()" class="dropdown-item exit-item">
                      <i class="el-icon-switch-button"></i>
                      <span>退出登录</span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-header>
    </el-container>

    <!-- 主体内容 -->
    <el-container class="main-container">
      <!-- 侧边栏 -->
      <el-aside class="app-aside">
        <el-menu 
          :default-active="$route.path" 
          router 
          class="sidebar-menu"
          background-color="transparent"
          text-color="#b4b7bd"
          active-text-color="#ffffff">
          
          <!-- 首页 -->
          <el-menu-item index="/" class="menu-item">
            <i class="el-icon-s-home menu-icon"></i>
            <span slot="title" class="menu-title">首页</span>
          </el-menu-item>
          
          <!-- 供需管理 -->
          <el-submenu index="2" class="menu-submenu">
            <template slot="title">
              <i class="el-icon-box menu-icon"></i>
              <span class="menu-title">供需管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/publish" class="submenu-item">
                <i class="el-icon-edit-outline"></i>
                <span>发布供需</span>
              </el-menu-item>
              <el-menu-item index="/supply-demand/my" class="submenu-item">
                <i class="el-icon-document"></i>
                <span>我的供需</span>
              </el-menu-item>
              <el-menu-item index="/supply-demand/list" class="submenu-item">
                <i class="el-icon-files"></i>
                <span>供需列表</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <!-- 供需线索 -->
          <el-menu-item index="/clue/list" class="menu-item">
            <i class="el-icon-data-analysis menu-icon"></i>
            <span slot="title" class="menu-title">供需线索</span>
          </el-menu-item>

          <!-- 热门排行 -->
          <el-menu-item index="/hot" class="menu-item">
            <i class="el-icon-trophy menu-icon"></i>
            <span slot="title" class="menu-title">热门排行</span>
          </el-menu-item>

          <!-- 个人中心 -->
          <el-submenu index="3" class="menu-submenu">
            <template slot="title">
              <i class="el-icon-user menu-icon"></i>
              <span class="menu-title">个人中心</span>
            </template>
            <el-menu-item-group>
              <!-- 我的收藏 -->
              <el-menu-item index="/favorite/list" class="submenu-item">
                <i class="el-icon-star-off menu-icon"></i>
                <span>我的收藏</span>
              </el-menu-item>
              <el-menu-item index="/personal" class="submenu-item">
                <i class="el-icon-user-solid"></i>
                <span>个人资料</span>
              </el-menu-item>
              <el-menu-item index="/center" class="submenu-item">
                <i class="el-icon-s-order"></i>
                <span>账户信息</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>

        </el-menu>

        <!-- 侧边栏底部装饰 -->
        <div class="sidebar-footer">
          <div class="footer-text">© 2025 数海领航 供需平台</div>
        </div>
      </el-aside>
      
      <!-- 主内容区域 -->
      <el-main class="app-main">
        <router-view/>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      user: {}
    }
  },
  mounted() {
    let userStr = localStorage.getItem("user");
    if (userStr) {
      this.user = JSON.parse(userStr);
    }
  },
  methods: {
    exit() {
      localStorage.removeItem("user");
      this.$message({
        message: '退出成功！',
        type: 'success',
        duration: 2000
      });
      this.$router.push("/login");
    },
    center() {
      this.$router.push("/center");
    }
  }
}
</script>

<style scoped>
/* ========== 布局容器 ========== */
.layout-wrapper {
  height: 100vh;
  overflow: hidden;
  background: var(--bg-page);
}

/* ========== 顶部导航栏 ========== */
.app-header {
  height: 65px !important;
  padding: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1000;
}

.header-content {
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  position: relative;
}

/* Logo区域 */
.header-left {
  display: flex;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  transition: transform 0.3s;
}

.logo-section:hover {
  transform: scale(1.02);
}

.logo-img {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s;
}

.logo-section:hover .logo-img {
  transform: rotate(5deg);
}

.app-title {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.title-text {
  font-size: 22px;
  font-weight: 700;
  color: white;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.title-slogan {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
}

/* 用户信息区域 */
.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar-wrapper {
  position: relative;
}

.user-avatar {
  border: 3px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s;
  cursor: pointer;
}

.user-avatar:hover {
  transform: scale(1.08);
  border-color: rgba(255, 255, 255, 0.6);
}

/* 在线状态徽章 */
.online-badge {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  background: #52c41a;
  border: 2px solid white;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(82, 196, 26, 0.6);
  animation: pulse-online 2s infinite;
}

@keyframes pulse-online {
  0%, 100% {
    box-shadow: 0 0 6px rgba(82, 196, 26, 0.6);
  }
  50% {
    box-shadow: 0 0 12px rgba(82, 196, 26, 0.9);
  }
}

.user-dropdown {
  cursor: pointer;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.15);
  transition: all 0.3s;
  color: white;
}

.el-dropdown-link:hover {
  background: rgba(255, 255, 255, 0.25);
}

.user-name {
  font-size: 14px;
  font-weight: 600;
}

/* 下拉菜单 */
.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.3s;
  color: #606266;
}

.dropdown-item i {
  font-size: 16px;
}

.dropdown-item:hover {
  color: var(--primary-color);
}

.exit-item:hover {
  color: #f56c6c;
}

/* ========== 主容器 ========== */
.main-container {
  height: calc(100vh - 65px);
}

/* ========== 侧边栏 ========== */
.app-aside {
  width: 240px !important;
  background: linear-gradient(180deg, #1a1f2e 0%, #252b3b 50%, #2a3142 100%);
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.15);
  position: relative;
}

.app-aside::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #764ba2, #667eea);
  background-size: 200% 100%;
  animation: gradientMove 3s linear infinite;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}

/* 自定义滚动条 */
.app-aside::-webkit-scrollbar {
  width: 6px;
}

.app-aside::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
}

.app-aside::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #667eea, #764ba2);
  border-radius: 3px;
  transition: all 0.3s;
}

.app-aside::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #7c8ef5, #8b5cb8);
}

/* 菜单样式 */
.sidebar-menu {
  border: none;
  padding: 20px 0 100px 0;
}

/* 菜单项 */
.menu-item {
  margin: 6px 14px;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  position: relative;
  border: 2px solid transparent;
}

/* 菜单项左侧指示条 */
.menu-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 0;
  background: linear-gradient(180deg, #667eea, #764ba2);
  border-radius: 0 4px 4px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 菜单项背景光晕 */
.menu-item::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 0;
  height: 0;
  background: radial-gradient(circle, rgba(102, 126, 234, 0.3), transparent);
  border-radius: 50%;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  z-index: 0;
}

.menu-item:hover {
  background: rgba(102, 126, 234, 0.12) !important;
  border-color: rgba(102, 126, 234, 0.2);
  transform: translateX(4px);
}

.menu-item:hover::before {
  height: 60%;
}

.menu-item:hover::after {
  width: 100%;
  height: 100%;
  opacity: 1;
}

/* 激活状态 */
.menu-item.is-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.1);
  transform: translateX(6px);
}

.menu-item.is-active::before {
  height: 80%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.4));
}

.menu-item.is-active::after {
  opacity: 0;
}

/* 图标动画 */
.menu-icon {
  font-size: 19px;
  margin-right: 14px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
}

.menu-item:hover .menu-icon {
  transform: scale(1.2) rotate(10deg);
  color: #fff;
  text-shadow: 0 0 8px rgba(102, 126, 234, 0.8);
}

.menu-item.is-active .menu-icon {
  transform: scale(1.15);
  color: #fff;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.menu-title {
  font-size: 14px;
  font-weight: 600;
  position: relative;
  z-index: 1;
  letter-spacing: 0.3px;
}

.menu-item.is-active .menu-title {
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* 子菜单标题 */
.menu-submenu >>> .el-submenu__title {
  margin: 6px 14px;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border: 2px solid transparent;
  overflow: hidden;
}

.menu-submenu >>> .el-submenu__title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 0;
  background: linear-gradient(180deg, #667eea, #764ba2);
  border-radius: 0 4px 4px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-submenu >>> .el-submenu__title:hover {
  background: rgba(102, 126, 234, 0.12) !important;
  border-color: rgba(102, 126, 234, 0.2);
  transform: translateX(4px);
}

.menu-submenu >>> .el-submenu__title:hover::before {
  height: 60%;
}

.menu-submenu.is-opened >>> .el-submenu__title {
  background: rgba(102, 126, 234, 0.15) !important;
  border-color: rgba(102, 126, 234, 0.25);
}

.menu-submenu.is-opened >>> .el-submenu__title::before {
  height: 70%;
}

/* 子菜单展开箭头 */
.menu-submenu >>> .el-submenu__icon-arrow {
  font-weight: 700;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-submenu.is-opened >>> .el-submenu__icon-arrow {
  color: #667eea;
  transform: rotateZ(180deg) scale(1.1);
}

/* 子菜单项 */
.submenu-item {
  margin: 4px 14px 4px 26px !important;
  border-radius: 10px;
  padding-left: 48px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  border: 2px solid transparent;
}

/* 子菜单项圆点指示器 */
.submenu-item::before {
  content: '';
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4);
}

/* 子菜单项连接线 */
.submenu-item::after {
  content: '';
  position: absolute;
  left: 32px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, rgba(102, 126, 234, 0.5), transparent);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.submenu-item:hover {
  background: rgba(102, 126, 234, 0.12) !important;
  border-color: rgba(102, 126, 234, 0.2);
  padding-left: 52px !important;
  transform: translateX(2px);
}

.submenu-item:hover::before {
  background: linear-gradient(135deg, #667eea, #764ba2);
  transform: translateY(-50%) scale(1.4);
  box-shadow: 0 0 8px rgba(102, 126, 234, 0.8);
}

.submenu-item:hover::after {
  width: 12px;
}

/* 子菜单激活状态 */
.submenu-item.is-active {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.85) 0%, rgba(118, 75, 162, 0.85) 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.15);
  padding-left: 52px !important;
  transform: translateX(4px);
}

.submenu-item.is-active::before {
  background: white;
  transform: translateY(-50%) scale(1.5);
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.8), 0 0 20px rgba(102, 126, 234, 0.6);
}

.submenu-item.is-active::after {
  width: 16px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), transparent);
}

.submenu-item i {
  font-size: 14px;
  margin-right: 10px;
  transition: all 0.3s;
}

.submenu-item:hover i {
  transform: scale(1.15);
}

.submenu-item.is-active i {
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* 菜单组样式 */
.sidebar-menu >>> .el-menu-item-group__title {
  padding: 0;
  height: 0;
  overflow: hidden;
}

/* 菜单项文字 */
.sidebar-menu >>> .el-menu-item,
.sidebar-menu >>> .el-submenu__title {
  height: 48px;
  line-height: 48px;
}

/* 子菜单内容区域 */
.sidebar-menu >>> .el-menu-item-group {
  padding: 8px 0;
}

/* 侧边栏底部 */
.sidebar-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  text-align: center;
  background: rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  font-weight: 500;
}

/* ========== 主内容区域 ========== */
.app-main {
  background: var(--bg-page);
  padding: 0;
  overflow-y: auto;
  height: calc(100vh - 65px);
}

/* 主内容滚动条 */
.app-main::-webkit-scrollbar {
  width: 8px;
}

.app-main::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.app-main::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* ========== 响应式设计 ========== */
@media (max-width: 768px) {
  .app-aside {
    width: 200px !important;
  }

  .logo-img {
    width: 40px;
    height: 40px;
  }

  .title-text {
    font-size: 18px;
  }

  .title-slogan {
    display: none;
  }

  .header-content {
    padding: 0 15px;
  }

  .menu-item,
  .submenu-item {
    margin: 2px 8px;
  }
}

@media (max-width: 480px) {
  .app-aside {
    width: 180px !important;
  }

  .title-text {
    font-size: 16px;
  }

  .user-name {
    display: none;
  }
}

/* ========== 动画效果 ========== */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>

<style>
/* 全局样式 - 不使用 scoped */
.el-dropdown-menu {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid #ebeef5 !important;
  padding: 8px !important;
}

.el-dropdown-menu__item {
  border-radius: 8px !important;
  padding: 10px 16px !important;
  margin: 2px 0 !important;
  transition: all 0.3s !important;
}

.el-dropdown-menu__item:hover {
  background: rgba(102, 126, 234, 0.08) !important;
}

.el-menu {
  background: transparent !important;
}
</style>
